import { AiseaApiFactory } from "@/api/aisea/apiFactory";

const vesselCrewRepository = AiseaApiFactory.get("enterpriseManningVesselCrewTodo");

const EnterpriseManningVesselCrewTodoService = (() => {
  const fetch = async () => {
    const res = await vesselCrewRepository.fetch();
    if (!res || !res.status) throw res;
    return res.data;
  };
  const fetchValue = async (crew_id, todo_id) => {
    const res = await vesselCrewRepository.fetchTodoValue(crew_id, todo_id);
    if (!res || !res.status) throw res;
    return res.data;
  };
  const updateValue = async (crew_id, todo_id, data) => {
    const res = await vesselCrewRepository.updateTodoValue(crew_id, todo_id, data);
    if (!res || !res.status) throw res;
    return res.data;
  };
  return { fetch, fetchValue, updateValue };
})();

export default EnterpriseManningVesselCrewTodoService;